import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private sidebarOpen = new BehaviorSubject<boolean>(false);
  sidebarOpen$ = this.sidebarOpen.asObservable();

  toggleSidebar() {
    this.sidebarOpen.next(!this.sidebarOpen.value);
  }

  setSidebar(isOpen: boolean) {
    if (this.sidebarOpen.value !== isOpen) {
      this.sidebarOpen.next(isOpen);
    }
  }

  closeSidebar() {
    this.setSidebar(false);
  }
}
